import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import CountryService from "../../services/countries/CountryService";
import { loadingCountryDropdown } from "../../store/slices/countries/countrySlice";

export const useCountry = () => {
  const dispatch: AppDispatch = useDispatch();

  const { countryDropdown } = useSelector(
    (state: RootState) => state.country
  );

  const fetchCountryDropdown = async (term: string) => {
    try {
      const response = await CountryService.fetchDropdown(term);

      const {
        // type,
        // title,
        // message,
        data,
        statusCode
      } = response;

      if (statusCode === 200) {
        dispatch(loadingCountryDropdown(data));

      }

    } catch (error) {
      console.error("Error al cargar países:", error);
    }
  };

  return {
    countryDropdown,
    fetchCountryDropdown,
  };
};
